import tokens from "tokens";

export function sizes(width, columns = 1) {
  return `(max-width: ${tokens.breakpoints["60"]}px) 90.32vw, (max-width: ${
    tokens.breakpoints["130"]
  }px) ${Math.round(100 / columns)}vw, ${width}px`;
}

export function srcset(width, imgRetina, imgDefault) {
  return `${imgRetina} ${width * 2}w, ${imgDefault} ${width}w`;
}
